// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-box[data-v-138d3fc8]  .label{font-weight:400;color:#86909c;flex-shrink:0}.info-box .value[data-v-138d3fc8]{font-weight:500;color:#586474}.chart[data-v-138d3fc8]{position:relative}.chart .chart-bg[data-v-138d3fc8]{position:absolute;height:200px;left:50%;top:0;transform:translate(-50%)}.desc-enterprise[data-v-138d3fc8]{font-size:14px;color:#646464;padding:16px}.desc-enterprise span[data-v-138d3fc8]{font-weight:600}", ""]);
// Exports
module.exports = exports;
